import { render, staticRenderFns } from "./CreateApiToken.vue?vue&type=template&id=28fd1b8c&scoped=true"
import script from "./CreateApiToken.vue?vue&type=script&lang=js"
export * from "./CreateApiToken.vue?vue&type=script&lang=js"
import style0 from "./CreateApiToken.vue?vue&type=style&index=0&id=28fd1b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd1b8c",
  null
  
)

export default component.exports